import { render, staticRenderFns } from "./Gasto.vue?vue&type=template&id=535c27ea"
import script from "./Gasto.vue?vue&type=script&lang=js"
export * from "./Gasto.vue?vue&type=script&lang=js"
import style0 from "./Gasto.vue?vue&type=style&index=0&id=535c27ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports